var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBetThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_18017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 5.33333C4.13943 5.33333 5.33333 4.13943 5.33333 2.66667C5.33333 1.19391 4.13943 0 2.66667 0C1.19391 0 0 1.19391 0 2.66667C0 4.13943 1.19391 5.33333 2.66667 5.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.33333C11.4728 5.33333 12.6667 4.13943 12.6667 2.66667C12.6667 1.19391 11.4728 0 10 0C8.52728 0 7.33337 1.19391 7.33337 2.66667C7.33337 4.13943 8.52728 5.33333 10 5.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 5.33333C18.8061 5.33333 20 4.13943 20 2.66667C20 1.19391 18.8061 0 17.3333 0C15.8605 0 14.6666 1.19391 14.6666 2.66667C14.6666 4.13943 15.8605 5.33333 17.3333 5.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 12.6668C4.13943 12.6668 5.33333 11.4729 5.33333 10.0002C5.33333 8.5274 4.13943 7.3335 2.66667 7.3335C1.19391 7.3335 0 8.5274 0 10.0002C0 11.4729 1.19391 12.6668 2.66667 12.6668Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.6668C11.4728 12.6668 12.6667 11.4729 12.6667 10.0002C12.6667 8.5274 11.4728 7.3335 10 7.3335C8.52728 7.3335 7.33337 8.5274 7.33337 10.0002C7.33337 11.4729 8.52728 12.6668 10 12.6668Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 12.6668C18.8061 12.6668 20 11.4729 20 10.0002C20 8.5274 18.8061 7.3335 17.3333 7.3335C15.8605 7.3335 14.6666 8.5274 14.6666 10.0002C14.6666 11.4729 15.8605 12.6668 17.3333 12.6668Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19.9998C11.4728 19.9998 12.6667 18.8059 12.6667 17.3332C12.6667 15.8604 11.4728 14.6665 10 14.6665C8.52728 14.6665 7.33337 15.8604 7.33337 17.3332C7.33337 18.8059 8.52728 19.9998 10 19.9998Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_18017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetThree);
export default __webpack_public_path__ + "static/media/bet-three.f837ccc96d445b50d562d8af0365ce06.svg";
export { ForwardRef as ReactComponent };